import styled from './MobileMenu.module.scss'
import PrevButton from '../../../../assets/Arrow-Right.svg'
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../module/rootStore';


const MobileMenu = () => {

  const { currentStep, stepsSetting, prevCurrentStep } = useStore().StepsStore
  return (
    <div className={styled.wrapper}>
      <div className={styled.left}>
        {
          currentStep > 0 &&
          <div className={styled.button} onClick={prevCurrentStep}>
            <img src={PrevButton} />
          </div>
        }
      </div>
      <div className={styled.title}>
        {stepsSetting[currentStep]?.title}
      </div>
      <div className={styled.right}>
        Paso {currentStep + 1} de 5
      </div>
    </div>
  )
}

export default observer(MobileMenu)